import { render, staticRenderFns } from "./PluginModal.vue?vue&type=template&id=0b40af09&scoped=true"
import script from "./PluginModal.vue?vue&type=script&lang=js"
export * from "./PluginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40af09",
  null
  
)

export default component.exports